import OrderUpdateRequest from "../../../api/raily/order/update/order-update.request";
import OrderUpdateParams from "./order-update-params";

const create = (params: OrderUpdateParams): OrderUpdateRequest => {
  return {
    forceAllowToll: params.forceAllowToll,
    orderId: params.orderId,
    rv1: params.rv1,
    rv2: params.rv2,
  };
};

const orderUpdateParamsFactory = {
  create,
};

export default orderUpdateParamsFactory;
